import { render, staticRenderFns } from "./modal-refazer.vue?vue&type=template&id=ca648e80&scoped=true"
import script from "./modal-refazer.vue?vue&type=script&lang=js"
export * from "./modal-refazer.vue?vue&type=script&lang=js"
import style0 from "./modal-refazer.vue?vue&type=style&index=0&id=ca648e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca648e80",
  null
  
)

export default component.exports